import { render, staticRenderFns } from "./changePoint.vue?vue&type=template&id=621d5615&scoped=true"
import script from "./changePoint.vue?vue&type=script&lang=js"
export * from "./changePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d5615",
  null
  
)

export default component.exports